import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Agents connected',
  attributeName: 'liveAgents',
  fields: [
    {
      attributeName: 'agents',
      type: FormInputTypes.LOG,
      label: 'Agents',
      filters:[],
      hasFilterText:false,
      logData:{
        logDataValues:"agentsData",
        channel:"liveLogs-Agents-",
        getUrl:"liveLogsAgentsPaginated/",
        hasRealTime:false
      },
      legend:[{
          letter:"C",
          text:"Connected",
          color:'bg-success'
        },
        {
          letter:"N",
          text:"Not connected",
          color:'bg-disconnected'
        },
        {
          letter:"W",
          text:"Warning",
          color:'bg-warning'
        }],
      textNoResults:'(No agents connected yet)'
    },
  ],
};
